import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import router from './router'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui';
import Vant from 'vant'
import 'vant/lib/index.css';
import i18n from './i18n';

import {time_format} from './assets/tool/index';
import { number_format, number_format2 } from "./assets/tool/number_format";

// 时间转换
Vue.prototype.time_format = time_format;

// 数字 1,000.00
Vue.prototype.number_format = number_format;
// 数字 1,000
Vue.prototype.number_format2 = number_format2;

Vue.use(Vant);
Vue.use(ElementUI);
Vue.use(Vuex);
Vue.config.productionTip = false

Vue.prototype.bus = new Vue();


new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
